import SelectTemplate from './SelectTemplate';
export default SelectTemplate;
